import utils from "../../utils/index.js";

/**
 * 从url中获取指定字段对应的参数
 *
 * @param {*} name
 * @returns
 */
function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}
// 获取去掉#/的url指定参数
function getHashQueryString(name) {
  var _reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  let url = window.location.href.replace("/#/", "/");
  if(!url.includes("?")){
      return null
  }
  var _r = url.split("?")[1].match(_reg);
  if (_r != null) return decodeURIComponent(_r[2]);
  return null;
}
// 获取带code的url指定参数
function getHashCodeQueryString(urls,name) {
  var _reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  let url =urls.replace("/#/", "/");
  if(!url.includes("?")){
      return null
  }
  var _r = url.split("?")[1].match(_reg);
  if (_r != null) return decodeURIComponent(_r[2]);
  return null;
}

/**
 * 获取验证码
 *
 * @param {*} phoneNumber
 * @param {*} type
 * @returns
 */
function getSms(phoneNumber, type) {
  return new Promise((resolve, reject) => {
    this.$http
      .post(
        utils.urls.sms,
        {
          mobile: phoneNumber,
          type: type,
        },
        {
          headers: {
            xfrom: utils.config.config.xfrom,
          },
        }
      )
      .then((res) => {
        console.log(res);

        resolve(res);
      })
      .catch((error) => {
        rejuct(error);
      });
  });
}

/**
 * 判断是否是三种带横线操作的手机
 *
 * @returns
 */
function isMaxScreenIphone() {
  // iPhone X、iPhone XS
  let isIPhoneX =
    /iphone/gi.test(window.navigator.userAgent) &&
    window.devicePixelRatio &&
    window.devicePixelRatio === 3 &&
    window.screen.width === 375 &&
    window.screen.height === 812;
  // iPhone XS Max
  let isIPhoneXSMax =
    /iphone/gi.test(window.navigator.userAgent) &&
    window.devicePixelRatio &&
    window.devicePixelRatio === 3 &&
    window.screen.width === 414 &&
    window.screen.height === 896;
  // iPhone XR
  let isIPhoneXR =
    /iphone/gi.test(window.navigator.userAgent) &&
    window.devicePixelRatio &&
    window.devicePixelRatio === 2 &&
    window.screen.width === 414 &&
    window.screen.height === 896;

  if (isIPhoneX || isIPhoneXSMax || isIPhoneXR) {
    return true;
  } else {
    return false;
  }
}

export default {
  getQueryString,
  getHashQueryString,
  getHashCodeQueryString,
  getSms,
  isMaxScreenIphone,
};
